import moment from "moment";
import * as yup from "yup";

import {
  ACCRUAL_DATE_DISPLAY_FORMAT,
  isEmptyDateValue,
} from "../helpers/accrualDateFormat";

const requiredMessage = (field: string) =>
  `El campo ${field} no puede quedar vacío`;

export const buildAccrualRowSchema = (accrualType: string) => {
  return yup.object({
    registrationDate: yup
      .string()
      .nullable()
      .test(
        "required-date",
        requiredMessage("Fecha"),
        (value) => !isEmptyDateValue(value),
      )
      .test(
        "valid-date-format",
        "El campo Fecha debe tener el formato dd/mm/aaaa",
        (value) => {
          if (isEmptyDateValue(value)) return true;

          return moment(value, ACCRUAL_DATE_DISPLAY_FORMAT, true).isValid();
        },
      ),
    description: yup.string().required(requiredMessage("Descripción")),
    vacationDays: yup
      .number()
      .typeError("El campo debe ser numérico")
      .required(requiredMessage("Días vacaciones"))
      .min(0, "Los días de vacaciones no pueden ser negativos"),
    vacationTaken: yup
      .number()
      .typeError("El campo debe ser numérico")
      .required(requiredMessage("Días tomados"))
      .min(0, "Los días tomados no pueden ser negativos"),
    primaPercentage: yup
      .number()
      .typeError("El campo debe ser numérico")
      // .min(1, "El porcentaje de prima no puede ser menor a 1") // TODO: descomentar al reactivar edición de prima vacacional 
      // .max(100, "El porcentaje de prima no puede ser mayor a 100") // TODO: descomentar junto con la línea anterior
      .nullable(),
    primaDays: yup
      .number()
      .typeError("El campo debe ser numérico")
      .min(0, "Los días de prima no pueden ser negativos")
      .nullable()
      .test(
        "prima-days-not-greater-than-vacation-days",
        "Los días de prima no pueden ser mayores a los días de vacaciones",
        function (value) {
          const { vacationDays } = this.parent;

          if (value == null || vacationDays == null) return true;

          return value <= Math.abs(vacationDays);
        },
      ),
  });
};
